import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createDeckCounter(k, initialCount, config = {}) {
    const startX = config.x || k.width() - 120;
    const startY = config.y || 10;

    // Icon configuration
    const iconType = config.iconType || "sprite"; // "sprite" or "rect"
    const spriteName = config.spriteName || "sheep";

    // Create the PARENT Actor (The Background)
    const counterActor = k.add([
        k.rect(110, 50, { radius: 8 }),
        k.color(0, 0, 0),
        k.opacity(0.6),
        k.pos(startX, startY),
        k.z(100),
        k.scale(1),
        k.fixed(),
        UI_TAGS.GENERIC_COUNTER
    ]);

    // Add icon
    if (iconType === "sprite") {
        counterActor.add([
            k.sprite(spriteName),
            k.pos(10, 10),
            k.scale(0.8),
            k.z(101),
        ]);
    } else if (iconType === "rect") {
        counterActor.add([
            k.rect(20, 28, { radius: 3 }),
            k.pos(15, 11),
            k.color(240, 240, 240),
            k.z(101),
            k.outline(2, k.rgb(150, 150, 150))
        ]);
    }

    // Add text
    const countText = counterActor.add([
        k.text(`x${initialCount}`, { size: 28, font: "lilita" }),
        k.color(255, 255, 255),
        k.z(101),
        k.scale(1),
        k.pos(60, 11)
    ]);


    let popTween = null; // Protects against rapid-fire updates

    counterActor.updateCount = (newCount) => {
        countText.text = `x${newCount}`;

        // Stop the old animation if it's still playing
        if (popTween) popTween.cancel();

        // Start a bouncy scale animation (From 1.4x size down to 1x size)
        popTween = k.tween(
            1.4,
            1,
            0.2,
            (v) => countText.scale = k.vec2(v),
            k.easings.easeOutBack
        );
    };

    return counterActor;
}